<template>
    <div class="base-card__content base-card__shadow plus-content base-card__zoom" :class="`plus-content_${classModifier}`">
        <div class="plus-content__plus"></div>
        <div class="plus-content__text">{{ caption }}</div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from "vue";
    import { type PlusCardData } from "../../models";
    import { computed } from "vue";

    const props = defineProps({
        cardData: {
            type: Object as PropType<PlusCardData>,
            required: true
        },
    });


    const caption = computed(() => props.cardData.getCaption());
    const classModifier = computed(()=> props.cardData.getClass());
</script>

<style lang="scss">
    @import url("styles.scss");
</style>